import {Field, FormikValues, useFormikContext} from "formik";
import TooltipPop from "../../../components/tooltip-pop";
import React from "react";
import styles from '../mna-info.module.scss';
import classnames from "classnames/bind";
import {BrokerageType, CustomerMnaNeedsDto} from "../../../model/customer/dto/customer-mna-needs-dto";
import {useInjection} from "inversify-react";
import {DialogManager} from "../../../components/dialog-manager";

const cx = classnames.bind(styles);

interface NeedsCustomerTypeProps {
    needs: CustomerMnaNeedsDto
    needsType: string
    setNeedsType: React.Dispatch<React.SetStateAction<BrokerageType>>
    available: string
}

const NeedsCustomerType = ({needs, needsType, setNeedsType, available}: NeedsCustomerTypeProps) => {
    const dialogManager = useInjection(DialogManager);
    const {setFieldValue} = useFormikContext<FormikValues>();

    const checkNeedsType = (e: React.ChangeEvent<HTMLInputElement>, type: BrokerageType) => {
        // M&A 등록을 했을 경우
        if (needs.isApplyNeeds) {
            if (type !== needs.type) {
                if (needs.type === 'CHECK') {
                    if(available !== 'TRUE' && (type === 'SELL' || type === 'SELL_ADVISORY' || type === 'ACQUIRE' || type === 'ACQUIRE_ADVISORY')) {
                        dialogManager.alert(`다른 씨오파트너 회원을 통해\n${available} 유형으로 등록된 기업입니다.`);
                    } else {
                        setFieldValue('companyType', type);
                        setNeedsType(type);
                    }
                } else {
                    e.preventDefault();
                    e.stopPropagation();

                    dialogManager.alert("M&A를 신청한 후에는\n다른 유형을 선택할 수 없습니다.", "중개 신청을 취소한 후에 다른 유형으로 선택 가능합니다.\n( 해당없음 이동 >> 중개신청 취소 클릭 )");
                }
            } else {
                setFieldValue('companyType', type);
                setNeedsType(type);
            }
        } else {
            if(available !== 'TRUE' && (type === 'SELL' || type === 'SELL_ADVISORY' || type === 'ACQUIRE' || type === 'ACQUIRE_ADVISORY')) {
                dialogManager.alert(`다른 씨오파트너 회원을 통해\n${available} 유형으로 등록된 기업입니다.`);
            } else {
                setFieldValue('companyType', type);
                setNeedsType(type);
            }
        }
    }

    return (
        <div className={cx('company-type')} role='group'>
            <p className={cx('type-title')}>고객 유형</p>
            <label className={cx('radio-btn')}>
                <Field
                    type='radio'
                    name='companyType'
                    onClick={() => setNeedsType('NONE')}
                    value='NONE'
                />
                해당없음
            </label>
            <label className={cx('radio-btn')}>
                <Field
                    type='radio'
                    name='companyType'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkNeedsType(e, "CHECK")}
                    value={"CHECK"}
                    checked={needsType === "CHECK"}/>
                검토가능
                <TooltipPop
                    contents="매각 검토가능기업으로 등록만 해두면, 잠재 인수자가 해당 기업과 유사한 조건에 관심을 보일 경우 씨오파트너 회원의 소개 연결을 통해 고객사 미팅을 진행할 수 있습니다."
                    eventStop={false}/>
            </label>
            <label className={cx('radio-btn')}>
                <Field
                    type='radio'
                    name='companyType'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkNeedsType(e, "SELL")}
                    value={"SELL"}
                    checked={needsType === "SELL"}/>
                매각희망
                <TooltipPop
                    contents="매각희망기업으로 등록 시 씨오 M&A센터를 통해 고객사 미팅을 진행하고, M&A중개계약 체결 후 잠재 인수자를 찾아드립니다."
                    eventStop={false}/>
            </label>
            <label className={cx('radio-btn')}>
                <Field
                    type='radio'
                    name='companyType'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkNeedsType(e, "SELL_ADVISORY")}
                    value={"SELL_ADVISORY"}
                    checked={needsType === "SELL_ADVISORY"}/>
                매각자문
                <TooltipPop
                    contents="매각자문기업으로 등록 시 씨오 M&A센터를 통해 고객사 미팅을 진행하고, 매각자문계약 체결합니다. 자문수수료는 딜 사이즈에 달라질 수 있어 고객사 미팅 후 견적서를 제공합니다."
                    eventStop={false}/>
            </label>
            <label className={cx('radio-btn')}>
                <Field
                    type='radio'
                    name='companyType'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkNeedsType(e, "ACQUIRE")}
                    value={"ACQUIRE"}
                    checked={needsType === "ACQUIRE"}/>
                인수희망
                <TooltipPop
                    contents="인수희망기업으로 등록 시 씨오 M&A센터를 통해 조건매칭 후보 매각기업을 추천받고, 인수중개를 진행할 수 있습니다."
                    eventStop={false}
                    rightSide={true}/>
            </label>
            <label className={cx('radio-btn')}>
                <Field
                    type='radio'
                    name='companyType'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkNeedsType(e, "ACQUIRE_ADVISORY")}
                    value={"ACQUIRE_ADVISORY"}
                    checked={needsType === "ACQUIRE_ADVISORY"}/>
                인수자문
                <TooltipPop
                    contents="인수자문기업으로 등록 시 씨오 M&A센터를 통해 고객사 미팅을 진행하고, 인수자문계약 체결합니다. 자문수수료는 딜 사이즈에 달라질 수 있어 고객사 미팅 후 견적서를 제공합니다."
                    eventStop={false}
                    rightSide={true}/>
            </label>
        </div>
    );
}

export default NeedsCustomerType;